import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useResponsive } from 'src/hooks/use-responsive';

import { fDate } from 'src/utils/format-time';

import Image from 'src/components/image';
import Iconify from 'src/components/iconify';
import TextMaxLine from 'src/components/text-max-line';

// ----------------------------------------------------------------------

export default function PostItem({ post }) {
  const { coverUrl, title, totalViews, totalComments, totalShares, createdAt } = post;

  return (
    <Card>
      <Image alt={title} src={coverUrl} ratio="16/9" />
      <PostContent
        title={title}
        totalViews={totalViews}
        totalComments={totalComments}
        totalShares={totalShares}
        createdAt={createdAt}
      />
    </Card>
  );
}

PostItem.propTypes = {
  post: PropTypes.object,
};

// ----------------------------------------------------------------------

export function PostContent({ title, createdAt, index }) {
  const mdUp = useResponsive('up', 'md');

  const linkTo = paths.post.details(title);

  const latestPostLarge = index === 0;

  return (
    <CardContent
      sx={{
        width: 1,
      }}
    >
      <Stack direction="row" alignItems="center" sx={{ mt: 2, mb: 1 }}>
        <Iconify
          width={16}
          icon="solar:calendar-date-bold"
          sx={{
            mr: 1,
            color: 'primary.main',
          }}
        />
        <Typography variant="caption" component="div" sx={{ color: 'text.disabled' }}>
          {fDate(createdAt)}
        </Typography>
      </Stack>

      <Link color="inherit" component={RouterLink} href={linkTo} aria-label="Blog post">
        <TextMaxLine variant={mdUp && latestPostLarge ? 'h5' : 'subtitle2'} line={2} persistent>
          {title}
        </TextMaxLine>
      </Link>
      <Link
        underline="none"
        color="inherit"
        component={RouterLink}
        href={linkTo}
        aria-label="Blog post"
      >
        <Typography
          sx={{
            mt: 3,
            mb: 2,
            '&:hover': {
              color: 'primary.main',
            },
          }}
          variant="caption"
          component="div"
        >
          READ MORE
        </Typography>
      </Link>
    </CardContent>
  );
}

PostContent.propTypes = {
  createdAt: PropTypes.string,
  index: PropTypes.number,
  title: PropTypes.string,
};
